(function(angular, module) {var searchBoxDirective;

searchBoxDirective = function() {
  'ngInject';
  return {
    restrict: 'E',
    templateUrl: 'components/searchBox',
    require: '?ngModel',
    scope: {
      search: '&',
      placeholder: '@'
    },
    controllerAs: 'ctrl',
    bindToController: true,
    controller: function($element) {
      'ngInject';
      var ngModel;
      ngModel = $element.controller('ngModel');
      if (ngModel == null) {
        return;
      }
      this.modelOptions = {
        updateOn: 'default blur',
        debounce: {
          "default": 200,
          blur: 0
        }
      };
      ngModel.$render = (function(_this) {
        return function() {
          _this.searchText = ngModel.$viewValue || '';
        };
      })(this);
      this.change = function() {
        var query;
        query = this.searchText;
        ngModel.$setViewValue(this.searchText);
      };
      this.clear = function() {
        ngModel.$setViewValue(void 0);
        ngModel.$render();
      };
    }
  };
};

module.directive('dybSearchBox', searchBoxDirective);
})(angular, angular.module("dybComponents"));